import axios from 'axios';

// The control panel keeps its own token, separate from the tenant login
export const PLATFORM_TOKEN_KEY = 'platformToken';

export const platformApi = axios.create({
  baseURL: `${(process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '')}/api/v1/platform`,
});

platformApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(PLATFORM_TOKEN_KEY);
  if (config.headers && token) {
    config.headers.Authorization = `jwt ${token}`;
  }
  return config;
});

platformApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const onLogin = window.location.pathname === '/platform/login';
    if (error?.response?.status === 401 && !onLogin) {
      localStorage.removeItem(PLATFORM_TOKEN_KEY);
      (window as any).location = '/platform/login';
    }
    return Promise.reject(error);
  }
);

export const errorMessage = (error: any) => error?.response?.data?.message || 'Something went wrong';

export const STATUS_LABEL: Record<string, string> = {
  trialing: 'Trial',
  active: 'Active',
  grace: 'Grace period',
  expired: 'Expired',
  cancelled: 'Cancelled',
};

export const STATUS_COLOR: Record<string, 'success' | 'info' | 'warning' | 'error' | 'default'> = {
  trialing: 'info',
  active: 'success',
  grace: 'warning',
  expired: 'error',
  cancelled: 'default',
};

export const EVENT_LABEL: Record<string, string> = {
  created: 'Created',
  trial_started: 'Trial started',
  activated: 'Activated',
  renewed: 'Renewed',
  extended: 'Extended',
  plan_changed: 'Plan changed',
  override_set: 'Override set',
  seats_changed: 'Seats changed',
  account_linked: 'Company linked',
  grace: 'Entered grace',
  expired: 'Expired',
  payment_recorded: 'Payment recorded',
  fair_use_alert: 'Fair-use alert',
  notice_sent: 'Notice sent',
};

export const formatDate = (date?: string | null) =>
  date ? new Date(date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '-';

export const formatDateTime = (date?: string | null) =>
  date ? new Date(date).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-';

export const formatMoney = (amount?: number | null) =>
  amount === undefined || amount === null ? '-' : `₹ ${Number(amount).toLocaleString('en-IN')}`;

// -1 = unlimited
export const formatLimit = (limit?: number | null) =>
  limit === undefined || limit === null ? '-' : limit < 0 ? 'Unlimited' : limit.toLocaleString('en-IN');

export const planLabel = (code?: string | null) =>
  code ? code.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()).replace(/^Pos\b/, 'POS') : 'Not migrated';
